import React, { useState } from "react";
import { UserFeedsType } from "../../types";
import { useMutation } from "@apollo/client";
import { UPDAT_USER_FEED } from "../../apollo/operations";
import { FeedUpdateEdit } from "..";
import { convertToCssColor } from "../../utils/formatColorCode";
import { handleIPFSUploads } from "../../utils/iPfsUpload";

type UserFeedContentProps = {
  userFeed: UserFeedsType | undefined;
  feedImages: string[];
  feedVideo: string[];
  editContent: boolean;
  setEditContent: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
  content?: string;
  isLocked: boolean | (() => void);
  toggle: boolean | (() => void);
};
const UserFeedContent: React.FC<UserFeedContentProps> = ({
  userFeed,
  feedImages,
  feedVideo,
  editContent,
  setEditContent,
  refetch,
  content,
  isLocked,
  toggle,
}) => {
  const maxLength = 400;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [imageUploadLoading, setImageUploadLoading] = React.useState(false);
  const [updateFeedContent, setUpdateFeedContent] = React.useState(content);
  const [imageCID, setImageCID] = useState<string[]>(feedImages);
  const [compressedVideoCid, setCompressedVideoCid] = useState(feedVideo);
  const [onChange, setOnChange] = React.useState(false);
  const backgroundColors = userFeed?.feedBackground || "";
  const backgroundColor = convertToCssColor(backgroundColors);
  const [ipfsVideos, setIpfsVideos] = useState<string[]>([]);
  const [thumbFile, setThumbFile] = React.useState<File[]>([]);
  const [compressedVideosArray, setCompressedVideosArray] = React.useState<
    File[]
  >([]);

  const [updateUserFeed, { loading }] = useMutation(UPDAT_USER_FEED, {
    onCompleted: (data) => {
      console.log(data, "updated");
      if (refetch) {
        refetch();
      }
      setImageUploadLoading(false);
    },
    onError: (err) => {
      console.log(err);
      const feedErrMsg = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(feedErrMsg);
    },
  });

  // console.log("compressedVideoCid: ", compressedVideoCid);
  // const videoURL = feedVideo && feedVideo;
  // console.log("loading: ", loading);

  const handleUpdateFeed = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (userFeed?.creator.id) {
      if (onChange === false) {
        console.log("return it is empty");

        return;
      }
      setImageUploadLoading(true);
      setOnChange(false);
      const ipfsVideo = compressedVideosArray.map((video, index) =>
        handleIPFSUploads([video, thumbFile[index]]).then((hashes) => {
          if (hashes && hashes.length === 2) {
            return `${hashes[0]} ${hashes[1]}`;
          } else {
            throw new Error("Failed to upload video or thumbnail to IPFS");
          }
        })
      );

      await Promise.all(ipfsVideo).then((fiteredVideo) => {
        updateUserFeed({
          variables: {
            data: {
              content: updateFeedContent,
              media: {
                imageUrl: [...imageCID],
                videoUrl: [...compressedVideoCid, ...fiteredVideo],
              },
            },
            where: {
              id: userFeed?.id,
            },
          },
        }).finally(() => {
          setEditContent(false);
          // setImageCID([]);
          setCompressedVideoCid([]);
          setOnChange(false);
          if (typeof toggle === "function") {
            toggle();
          }
        });
      });
    } else {
      console.log("error updating");
    }
  };

  return (
    <>
      {!editContent && !loading ? (
        feedVideo?.length || feedImages?.length ? (
          <div className="w-[98%] block lg:md:whitespace-pre-line text-black whitespace-pre-line p-1 px-4 break-words text-justify font-SegoeUI mb-2 gap-2 text-sm font-light">
            {content && content.length <= maxLength
              ? content
              : isExpanded
              ? content
              : content?.slice(0, maxLength)}
            {content && content.length > maxLength && (
              <span
                className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {!isExpanded ? " ... See more" : " ... See less"}
              </span>
            )}
          </div>
        ) : (
          <div
            className={`w-[98%] block whitespace-pre-line break-words text-start font-SegoeUI gap-2 px-4 
            ${
              content && content.length > 100
                ? `${
                    backgroundColor.length === 0
                      ? `p-1 text-base font-normal h-auto mb-7`
                      : "p-5 text-base font-normal h-auto mb-7"
                  }`
                : `  ${
                    backgroundColor.length === 0
                      ? "py-16 h-full font-medium lg:md:px-[52px] px-11 lg:text-2xl text-lg mb-7"
                      : "py-[100px] h-full font-medium lg:md:px-[52px] px-11 lg:text-2xl text-lg mb-7"
                  }  `
            }
        `}
            style={{ background: backgroundColor }}
            key={content}
          >
            {content && content.length <= maxLength
              ? content
              : isExpanded
              ? content
              : content?.slice(0, maxLength)}
            {content && content.length > maxLength && (
              <span
                className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {!isExpanded ? "... See more" : "... See less"}
              </span>
            )}
          </div>
        )
      ) : (
        editContent &&
        isLocked && (
          <FeedUpdateEdit
            setEditContent={setEditContent}
            userFeed={userFeed}
            feedImage={feedImages}
            updateFeedContent={updateFeedContent}
            handleUpdateFeed={handleUpdateFeed}
            loading={loading}
            imageUploadLoading={imageUploadLoading}
            setUpdateFeedContent={setUpdateFeedContent}
            backgroundColor={backgroundColor}
            feedVideos={feedVideo}
            setImageCID={setImageCID}
            toggle={toggle}
            imageCID={imageCID}
            setCompressedVideoCid={setCompressedVideoCid}
            compressedVideoCid={compressedVideoCid}
            setOnChange={setOnChange}
            onChange={onChange}
            setIpfsVideos={setIpfsVideos}
            ipfsVideos={ipfsVideos}
            setThumbFile={setThumbFile}
            setCompressedVideosArray={setCompressedVideosArray}
          />
        )
      )}
    </>
  );
};

export default UserFeedContent;
